// based on https://coderwall.com/p/urxpsa/remove-falsy-values-or-empty-strings-from-javascript-objects
const removeFalsy = (obj) => {
  let newObj = {};

  Object.keys(obj).forEach((prop) => {
    if (obj[prop]) {
      newObj[prop] = obj[prop];
    }
  });

  return newObj;
};

const formatLocationIdForBackend = (obj) => {
  obj.originLocationId = obj.originLocationId.value;
  obj.destinationLocationId = obj.destinationLocationId.value;

  return obj;
};

const renameSqftForBackend = (obj) => {
  //if originSqFtMiniStorage or destinationSqFtMiniStorage, switch them out for just sqft
  if (obj.originTypeOf === "storage" && obj.originSqFtMiniStorage) {
    obj.originSqFt = obj.originSqFtMiniStorage;
  }

  if (obj.destinationTypeOf === "storage" && obj.destinationSqFtMiniStorage) {
    obj.destinationSqFt = obj.destinationSqFtMiniStorage;
  }

  //if originSqFtApt or destinationSqFtApt, switch them out for just sqft
  if (obj.originTypeOf === "apt" && obj.originSqFtApt) {
    obj.originSqFt = obj.originSqFtApt;
  }

  if (obj.destinationTypeOf === "apt" && obj.destinationSqFtApt) {
    obj.destinationSqFt = obj.destinationSqFtApt;
  }

  return obj;
};

// from https://stackoverflow.com/questions/27194359/javascript-pluralize-a-string
const maybePluralize = (count, noun, suffix = "s") => {
  return `${count} ${noun}${count !== 1 ? suffix : ""}`;
};

export {
  removeFalsy,
  formatLocationIdForBackend,
  renameSqftForBackend,
  maybePluralize,
};
